import styled from 'styled-components';

export const ALFRED_FOOTER_SPACER_HEIGHT_PX = 188;

export const AlfredFooterRoot = styled.footer<{
  $hide?: boolean;
  $fixed?: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 12px 20px 12px;
  visibility: ${({ $hide }) => ($hide ? 'hidden' : 'visible')};

  ${({ $fixed }) =>
    $fixed
      ? `
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: var(--z-index-chat-input);
    background: transparent;
  `
      : `
    position: sticky;
    bottom: 0;
    inset-inline: 0;
    z-index: 1;
  `}
`;

export const LeftControls = styled.div<{ $hide?: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 24px;
  grid-column: 1;
  margin-right: 4px;
  ${({ $hide }) => $hide && 'display: none;'}
`;

export const InputRegion = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  grid-column: 2;
  min-width: 300px;
  --chat-message-width: 1000px;
`;
